import script from "./KeywordInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeywordInput.vue?vue&type=script&setup=true&lang=ts"

import "./KeywordInput.vue?vue&type=style&index=0&id=3875e70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3875e70e"]])

export default __exports__